import moment from 'moment';

const collator = new Intl.Collator('en', {
  usage: 'sort',
  sensitivity: 'base',
});

export const sortArrayOfObjects = (list, sortBy) =>
  list.sort((prev, next) => collator.compare(sortBy(prev), sortBy(next)));

export const sortByTime = (order, time1, time2) => {
  const fakeDate = '2020-01-01';
  if (order === 'asc') {
    return new Date(`${fakeDate} ${time2}`).getTime() > new Date(`${fakeDate} ${time1}`).getTime() ? 1 : -1;
  }
  return new Date(`${fakeDate} ${time1}`).getTime() > new Date(`${fakeDate} ${time2}`).getTime() ? 1 : -1;
};

export const sortAlphabetically = (order, value1, value2) => {
  if (!(value1 && value2)) {
    return !value1 ? 1 : -1;
  }

  if (order === 'asc') {
    return value2.localeCompare(value1, 'en', { sensitivity: 'base' });
  }
  return value1.localeCompare(value2, 'en', { sensitivity: 'base' });
};

export const sortByDateAndTime = (order, date1, date2) => {
  if (order === 'asc') {
    return new Date(date2).getTime() > new Date(date1).getTime() ? 1 : -1;
  }
  return new Date(date1).getTime() > new Date(date2).getTime() ? 1 : -1;
};

const longestCommonPrefix = (a, b) => {
  let i = 0;
  while (i < a.length && i < b.length && a[i] === b[i]) {
      i++;
  }
  return i;
};

export const sortBySimilar = (a, b, target) => {
  const prefixA = longestCommonPrefix(a.toLowerCase(), target?.toLowerCase() || '');
  const prefixB = longestCommonPrefix(b.toLowerCase(), target?.toLowerCase() || '');
  return prefixB - prefixA;
};

const getPickupReadyOrder = (rescue) => {
  if (rescue?.location_donor_link_active && rescue?.rescue_confirmed) {
    return 0; // Highest priority
  }

  if (rescue?.location_donor_link_active && !rescue?.rescue_confirmed) {
    return 1; // Second priority
  }

  return 2; // Lowest priority
};

export const sortByPickupReady = (order, a, b) =>
  order === 'asc' ? getPickupReadyOrder(a) - getPickupReadyOrder(b) : getPickupReadyOrder(b) - getPickupReadyOrder(a);

export const sortByDateAndPickupWindowStartAndEndTime = ({
  order = 'asc',
  firstDate,
  firstBegin,
  firstEnd,
  secondDate,
  secondBegin,
  secondEnd,
  dateFormat = 'YYYYMMDD',
}) => {
  const orderMultiplier = order === 'asc' ? 1 : -1;

  const date1 = moment(firstDate, dateFormat).format('YYYY-MM-DD');
  const date2 = moment(secondDate, dateFormat).format('YYYY-MM-DD');

  const pickupDate1 = new Date(`${date1} 00:00`);
  const pickupBegin1 = new Date(`${date1} ${firstBegin}`);
  const pickupEnd1 = new Date(`${date1} ${firstEnd}`);

  const pickupDate2 = new Date(`${date2} 00:00`);
  const pickupBegin2 = new Date(`${date2} ${secondBegin}`);
  const pickupEnd2 = new Date(`${date2} ${secondEnd}`);

  return (pickupDate1 - pickupDate2) * orderMultiplier || pickupBegin1 - pickupBegin2 || pickupEnd1 - pickupEnd2;
};

export const sortSelectedFirst =
  (compareFn, { getRowId, selectedIds }) =>
  (item1, item2) => {
    const id1 = getRowId(item1);
    const id2 = getRowId(item2);
    const selected1 = selectedIds.has(id1);
    const selected2 = selectedIds.has(id2);

    if (selected1 !== selected2) {
      return selected1 ? -1 : 1;
    }

    return compareFn(item1, item2);
  };
